module.exports = __webpack_public_path__ + "static/img/product-4.cfdb3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-4.png
// module id = gUOz
// module chunks = 1